import { Card, Divider, Flex, Select, Space, Typography } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import api from "../../../../api";
import { GridMinMax } from "../../../../assets/styles/GlobalStyle";
import Loader from "../../../../components/Loader";
import { TranslationsField } from "../../../../domain/types";
import { useAppSelector } from "../../../../store";
import { AppState } from "../../../../store/appSlice";
import AdminLangSwicher from "../../../admin_components/AdminLangSwicher";

const { Text } = Typography;

const InternationalTplManagePages = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { field_Language } = useAppSelector(
    (data: { app: AppState }) => data.app
  );

  // page slugs
  const pageSlugs: {
    id: number;
    slug: string;
    translations: TranslationsField<{ text: string }>;
  }[] = [
    {
      id: 1,
      slug: "international-tpl-which-country-to-drive",
      translations: {
        en: {
          text: "Insurance country",
        },
        ge: {
          text: "დაზღვევის ქვეყანა",
        },
      },
    },
    {
      id: 2,
      slug: "international-tpl-insurance-period",
      translations: {
        en: {
          text: "Insurance period",
        },
        ge: {
          text: "სადაზღვევო პერიოდი",
        },
      },
    },
    {
      id: 3,
      slug: "international-tpl-personal-info",
      translations: {
        en: {
          text: "Your personal info",
        },
        ge: {
          text: "თქვენი პირადი ინფორმაცია",
        },
      },
    },
    {
      id: 4,
      slug: "international-tpl-car-info",
      translations: {
        en: {
          text: "Car info",
        },
        ge: {
          text: "მანქანის ინფორმაცია",
        },
      },
    },
    {
      id: 5,
      slug: "international-tpl-offer",
      translations: {
        en: {
          text: "Offers",
        },
        ge: {
          text: "შეთავაზებები",
        },
      },
    },
    {
      id: 6,
      slug: "international-tpl-check-info",
      translations: {
        en: {
          text: "Check information",
        },
        ge: {
          text: "ინფორმაციის გადამოწმება",
        },
      },
    },
  ];

  // selected slug
  const [selectedSlug, setSelectedSlug] = useState<string | null>(null);

  // get pet flow
  const { data: pageTextArry, isLoading: isPageTextArrayLoading } =
    api.useGetTplFlowPageTextsBySlugQuery(selectedSlug as string, {
      skip: !selectedSlug && true,
    });
  console.log("pageTextArry", pageTextArry);

  const mainLoading = isPageTextArrayLoading;

  return mainLoading ? (
    <Loader />
  ) : (
    <>
      <Flex gap={20} justify="space-between" align="flex-end">
        <Space direction="vertical" style={{ width: "100%" }}>
          <Text>{t("choosePage")}</Text>
          <Select
            size="large"
            style={{
              width: "100%",
            }}
            placeholder={t("choosePage")}
            value={selectedSlug || undefined}
            onChange={(value) => setSelectedSlug(value)}
            options={[
              ...pageSlugs.map((item) => ({
                value: item.slug,
                label: item?.translations?.[field_Language]?.text,
              })),
            ]}
          />
        </Space>

        <AdminLangSwicher />
      </Flex>

      {pageTextArry && (
        <>
          <Divider />

          <GridMinMax align="stretch">
            {pageTextArry?.translations && (
              <Card
                hoverable
                onClick={() =>
                  navigate(
                    `/manage-international-tpl-pages-edit/${selectedSlug}`
                  )
                }
                style={{ cursor: "pointer" }}
              >
                {pageTextArry?.translations?.[field_Language]?.title && (
                  <Space direction="vertical">
                    <Text type="secondary">{t("title")}</Text>
                    <Text>
                      {pageTextArry?.translations?.[field_Language]?.title}
                    </Text>
                  </Space>
                )}

                <Divider variant="dashed" />

                {pageTextArry?.translations?.[field_Language]?.stepName && (
                  <Space direction="vertical">
                    <Text type="secondary">{t("stepName")}</Text>
                    <Text>
                      {pageTextArry?.translations?.[field_Language]?.stepName}
                    </Text>
                  </Space>
                )}
              </Card>
            )}

            {pageTextArry?.listItems?.map((item, index) => (
              <Card
                hoverable
                key={index}
                onClick={() =>
                  navigate(
                    `/manage-international-tpl-pages-edit/${selectedSlug}/${item?.id}`
                  )
                }
              >
                {item?.translations?.[field_Language]?.title && (
                  <Space direction="vertical">
                    <Text type="secondary">{t("title")}</Text>
                    <Text>{item?.translations?.[field_Language]?.title}</Text>
                  </Space>
                )}

                <Divider variant="dashed" />

                {item?.translations?.[field_Language]?.body && (
                  <>
                    <Space direction="vertical">
                      <Text type="secondary">{t("body")}</Text>
                      <Text>{item?.translations?.[field_Language]?.body}</Text>
                    </Space>
                  </>
                )}
              </Card>
            ))}
          </GridMinMax>
        </>
      )}
    </>
  );
};

export default InternationalTplManagePages;
